import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@paypalcorp/pp-react';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

class BasicInputField extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    id: PropTypes.string,
    validateOnBlur: PropTypes.bool,
    readOnly: PropTypes.bool,
    helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    type: PropTypes.string,
    customError: PropTypes.string,
    showError: PropTypes.bool,
    className: PropTypes.string,
    validateOnChange: PropTypes.bool,
  };

  render() {
    const {
      input,
      label,
      meta: { touched, error, active },
      id,
      validateOnBlur,
      readOnly,
      helpText,
      customError,
      showError,
      className,
      validateOnChange = false,
    } = this.props;

    const errorMsg = error || customError,
      hasError =
        showError ||
        (validateOnChange && errorMsg) ||
        (validateOnBlur ? !active && touched && errorMsg : touched && errorMsg),
      type = this.props.type || 'text';

    if (hasError && !active) {
      trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
        error_code: 'INPUT_FIELD_VALIDATION_ERROR',
        error_desc: id,
        error_detail: errorMsg,
      });
    }

    return (
      <TextInput
        name={label}
        id={id}
        label={label}
        type={type}
        readOnly={readOnly}
        className={className}
        errorText={`${hasError ? errorMsg : ''}`}
        helperText={helpText}
        {...input}
      />
    );
  }
}
export default BasicInputField;
